// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-wFPl","right":"styles_right__1d6DF"};